import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import TextField from '@mui/material/TextField';
import {
    getAudit, getProductTypes, auditCategory, getBrands, auditBrand, getAudits, clearProductTypeList, clearBrandList, completeAudit, verifyAudit, recountAudit, clearInventoryAudit,
    removeProductInAduit, addProductsToAduit, updateAuditProductQuantity, updateAuditProductNotes, updateAuditName, clearSelectAdjustmentProduct, setSelectAdjustmentProduct,
    getProductsBarcodeInventoryAudit, updateAuditProductExpectedQuantity, updateAuditProductDiffQty, getAuditUncounted, getAuditCategories
} from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import { mapInventoryAudit } from 'utils/mappers'
import { auditViewCrumb, auditAddCrumb } from 'utils/breadcrumbInfo';
import { getBarcodeType } from 'utils/helpers';
import { selectInventoryAuditModel } from 'selectors/entitySelector';
import { Barcode } from 'constants/enums';
import WithRouter from 'custom/withRouter';
import BarcodeReader from 'library/readBarcode';
// Basic Components
import TextInputOnBlurCallApi from 'screens/components/basic/TextInputOnBlurCallApi';
import SelectInput from 'screens/components/basic/SelectInput';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import Grid from 'screens/components/basic/Grid';;
import DatePickerInput from 'screens/components/basic/DatePickerInput';

import AuditProductSave from './AuditProductSave';
import AdjustInventoryDialog from './AdjustInventoryDialog';
import InventoryAuditProductsTable from './InventoryAuditProductsTable';
import PageHeader from 'screens/components/basic/PageHeader';
import DataGrid from './DataGrid';


class InventoryAudit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: "",
            errorNoAddedItems: false,
            auditProducts: [],
            category: false,
            orderBy: 'ASC',
            sortBy: 'name',
            openAdjust: false,
            productId: 0,
            warehouseType: 0,
            countedCost: 0,
            diffQty: 0,
            diffCost: 0,
            newquantity: 0,
            productNameSearch: '',
            productSKUSearch: '',
            highlightId: null,
            selectedRows: [],
            activePage: 1,
            itemsPerPage: 25,
            productLength: 0,
            productState: [], 
            sortedProducts: [],
            isAdjust: false
        };
        this.sort = this.sort.bind(this);
        this.addProduct = this.addProduct.bind(this);
        this.barcodeReader = new BarcodeReader();
        this.agGridRef = React.createRef();
    }

    componentWillMount = () => {
        const auditId = this.props.params ? this.props.params.id : 0;

        if (auditId && auditId != 0) {
            this.setState({ status: "EDIT" });
            this.props.getAudit({ Id: auditId, branchId: this.props.branchId, getQuantities: true });
        }
        else {
            this.setState({ status: "ADD" });
            this.props.formInput("", "InventoryAuditTitleName");
        }
        this.props.getProductTypes();
        this.props.getBrands();
        this.props.getAuditCategories({ branchId: this.props.branchId });
    }

    componentWillReceiveProps(newProps) {
        if (newProps.auditCategoryListTimeStamp && newProps.auditCategoryListTimeStamp !== this.props.auditCategoryListTimeStamp) {
            //add products to audit, call api
            let productsToAdd = [];
            newProps.auditCategoryList.map(item => {
                productsToAdd.push({ Id: item.id });
            });

            this.addProductsToAudit(productsToAdd);
        }

        if (newProps.auditBrandListTimeStamp && newProps.auditBrandListTimeStamp !== this.props.auditBrandListTimeStamp) {
            //add products to audit, call api
            let productsToAdd = [];
            const warehouseType = this.props.form['InventoryAuditSelectedWarehouse'];

            newProps.auditBrandList.map(item => {
                productsToAdd.push({ Id: item.id, WarehouseTypeId: warehouseType });
            });
            this.addProductsToAudit(productsToAdd);
        }

        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)) {
            this.saveSuccess();
        }

        if (newProps.adjustProductSuccessTimeStamp && newProps.adjustProductSuccessTimeStamp !== this.props.adjustProductSuccessTimeStamp) {
            this.closeDialogAdjustment();
            this.props.getAudit({ Id: this.props.params ? this.props.params.id : 0, branchId: this.props.branchId, getQuantities: true });
        }

        // This part no longer used 
        if (newProps.inventoryAuditScan != undefined && newProps.inventoryAuditScan != this.props.inventoryAuditScan) {
            let found = this.props.inventoryAuditProducts.filter(item => item.id == newProps.inventoryAuditScan.id);
            if (found.length == 0) {
                this.addProductsToAudit([{ Id: newProps.inventoryAuditScan.id }], true);
            } else {
                this.setState({
                    highlightId: found[0].id
                }, () => setTimeout(() => {
                    this.setState({
                        highlightId: null
                    })
                }, 5000));

                this.scroll(found[0].id, found[0].warehouseType);
            }
        }

        if (newProps.uncountedCutoffDate && newProps.uncountedCutoffDate != this.props.uncountedCutoffDate) {
            const date = new Date(newProps.uncountedCutoffDate).toISOString().slice(0, 10)
            this.props.getAuditUncounted({ branchId: this.props.branchId, date })
        }

        if (newProps.form['InventoryAuditSelectedCategory'] != this.props.form['InventoryAuditSelectedCategory']) {
            this.props.clearFormInput(`SelectedSubCategory`);
            this.props.clearFormInput(`SelectedSubSubCategory`);
        }

        if (newProps.form['SelectedSubCategory'] != this.props.form['SelectedSubCategory']) {
            this.props.clearFormInput(`SelectedSubSubCategory`);
        }

        if (newProps.form['SelectedUncountedCategory'] != this.props.form['SelectedUncountedCategory']) {
            this.props.clearFormInput(`SelectedUncountedSubCategory`);
            this.props.clearFormInput(`SelectedUncountedSubSubCategory`);
        }

        if (newProps.form['SelectedUncountedSubCategory'] != this.props.form['SelectedUncountedSubCategory']) {
            this.props.clearFormInput(`SelectedUncountedSubSubCategory`);
        }

        if (newProps.inventoryAuditProducts !== this.props.inventoryAuditProducts && this.state.isAdjust){
            this.adjustProducts(this.props.inventoryAuditProducts, newProps.inventoryAuditProducts);
        }
    }

    componentDidUpdate(prevProps) {
        // Only call initialProducts when the length has changed (added/deleted)
        if (prevProps.inventoryAuditProducts.length !== this.props.inventoryAuditProducts.length) {
            this.initialProducts();
        }
    }

    componentDidMount() {
        window.addEventListener("keypress", this.barcodeListener);
        if (this.props.inventoryAuditProducts && this.props.inventoryAuditProducts.length > 0) {
            this.initialProducts();
        }
    }

    componentWillUnmount() {
        this.props.clearProductTypeList();
        this.props.clearBrandList();
        this.props.clearInventoryAudit();
        this.props.clearFormInput(`InventoryAuditTitleName`);
        this.props.clearFormInput(`InventoryAuditSelectedWarehouse`);
        this.props.clearFormInput(`InventoryAuditSelectedCategory`);
        this.props.clearFormInput(`SelectedSubCategory`);
        this.props.clearFormInput(`SelectedSubSubCategory`);
        this.props.clearFormInput(`InventoryAuditSelectedBrand`);
        this.props.clearFormInput(`UncountedCutoffDate`);
        this.props.clearFormInput(`SelectedUncountedCategory`);
        this.props.clearFormInput(`SelectedUncountedSubCategory`);
        this.props.clearFormInput(`SelectedUncountedSubSubCategory`);
        window.removeEventListener("keypress", this.barcodeListener);
    }

    barcodeListener = () => {
        if (document.activeElement.tagName != "INPUT") {
            this.barcodeReader.listening(this.getProductByBarcode);
        }
    }

    sortProducts = (products) => {
        if (this.state.sortBy == "name") {
            this.state.orderBy == "ASC"
              ? products.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
              : products.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1);
        } else if (this.state.sortBy == "sku") {
            this.state.orderBy == "ASC"
            ? products.sort((a, b) => a.sku.toLowerCase() > b.sku.toLowerCase() ? 1 : -1)
            : products.sort((a, b) => a.sku.toLowerCase() > b.sku.toLowerCase() ? -1 : 1);
        } else if (this.state.sortBy == "newquantity") {
            this.state.orderBy == "ASC"
            ? products.sort((a, b) => a.newquantity > b.newquantity ? 1 : -1)
            : products.sort((a, b) => a.newquantity > b.newquantity ? -1 : 1);
        }

        return products;
    }

    updateProductState = (products) => {
        let productState = products.map(x => ({
            id: x.id,
            name: x.name,
            sku: x.sku,
            location: x.location,
            BranchId: this.props.branchId,
            inStock: x.inStock,
            expectedQty: x.expectedQty,
            newquantity: x.newquantity,
            notes: x.notes,
            wac: x.wac,
            needRecount: x.needRecount,
            warehouseType: x.warehouseType,
            warehouseTypeName: this.changeWarehouseTypeIdToName(x.warehouseType),
        }));
      
        // Filter if status is 4 and user can't manage the audit
        if (this.props.inventoryAudit.status === 4 && !this.props.canManageAudit) {
            productState = productState.filter(x => x.needRecount);
        }

        return productState;
    }
    
    initialProducts = () => {
        const products = this.sortProducts([...this.props.inventoryAuditProducts]);
        const productState = this.updateProductState(products);

        this.setState({ 
            sortedProducts: productState, 
            productLength: productState.length, 
            productState: productState.slice(0, this.state.itemsPerPage)
        })
    }

    paginateProducts(page) {
        const {itemsPerPage, sortedProducts } = this.state;
        const page2 = page - 1;
        const start = page2 * itemsPerPage;
        const end = start + itemsPerPage;
        const nextPageProducts = sortedProducts.slice(start, end);
        // console.log(`page: ${page} start: ${start} end: ${end}, ${nextPageProducts.map(item => item.sku)}`);
        // console.log(nextPageProducts, start, end);
        this.setState({
            activePage: page,
            productState: [...nextPageProducts],
            isLoading: false,  // Reset loading flag after products are loaded
        });
    }

    adjustProducts = (current, newItems) => {
        const updatedProducts = this.updateProductsForAdjust(current, newItems);
        const sortedProducts = this.sortProducts([...updatedProducts]);
        const productState = this.updateProductState(sortedProducts);

        const { activePage, itemsPerPage } = this.state;
        const page2 = activePage - 1;
        const start = page2 * itemsPerPage;
        const end = start + itemsPerPage;

        this.setState({ 
            sortedProducts, 
            productState: productState.slice(start, end)
        })
        // console.log(productState.slice(start, end));
    };

    // Update
    updateProductsForAdjust = (current, newItems) => {
        return current.map(product => {
          const updatedProduct = newItems.find(newProduct => newProduct.id === product.id);
          return updatedProduct ? { ...product, ...updatedProduct } : product;
        });
    };

    getProductByBarcode = (barcodeStr) => {
        const barcode = barcodeStr.replace(/^\]C1/, '');
        const barcodeType = getBarcodeType(barcode);

        const product = this.props.inventoryAuditProducts.find(p => {
            // Barcode matches data in DB - barcode, product varation UPC
            if (p.barcodes.includes(barcode)) return p;

            // Scan SKU
            else if (p.sku === barcode) return p;

            // Product label : Z0000012456
            else if (barcodeType === Barcode.Product && p.id === parseInt(barcode.replace("Z", "", 10))) return p;

            // Stacked barcode : (01)00628176379852(13)220830(10)0501
            else if (barcodeType === Barcode.Stacked) {
                const productBarcode = parseInt(barcode.substring(2, 16)).toString();

                if (p.barcodes.find(b => b.includes(productBarcode))) return p;
                else if (p.barcodes.find(b => b.substring(0, b.length - 1) == productBarcode.substring(0, productBarcode.length - 1))) return p; //ignore last digit
                else if (p.barcodes.find(b => b.substring(2, 13) == productBarcode.substring(0, productBarcode.length - 1))) return p;
                else if (p.barcodes.find(b => productBarcode.length == 14 && b.substring(0, b.length - 1) == productBarcode.substring(2, productBarcode.length - 1))) return p;
            }
        });

        if (product) {
            if (this.props.inventoryAuditProducts.length <= this.state.itemsPerPage){
                this.scroll(product.id, product.warehouseType)
            }else{
                const productState = this.state.sortedProducts.filter(x => x.id === product.id);
                this.setState({ productState, productLength: productState.length, activePage: 1 }, () => {
                    this.scroll(product.id, product.warehouseType)
                })
            }
        } else {
            this.props.showError("This product does cannot be found, please check SKU and try again");
        }
    }

    saveSuccess = () => {
        this.props.showAuditSuccess("Inventory Audit Complete Success");
        this.callListView();
    }

    callListView() {
        this.props.navigate("/inventoryaudit/");
    }

    addProduct = (product) => {
        const warehouseType = this.props.form['InventoryAuditSelectedWarehouse'];
        if (this.props.inventoryAuditProducts.length == 0 || this.props.inventoryAuditProducts.filter(x => x.id == product.id && x.warehouseType == warehouseType).length == 0) {
            let productsToAdd = [{ Id: product.id, WarehouseTypeId: warehouseType }];
            //add product to audit
            this.addProductsToAudit(productsToAdd);
        }
        else {
            if (product.name) this.props.showError(`Product ${product.name} already added as an Item for this Audit.`);
        }
    }

    addProductsToAudit = (products, scanned = false) => {
        let auditId = this.props.params ? this.props.params.id : 0;

        let model = {
            BranchId: this.props.branchId,
            Id: Number(auditId),
            InventoryAuditProducts: products,
            Scanned: scanned
        }

        this.props.addProductsToAduit(model);
    }

    deleteProduct = (product) => {
        //remove product to audit
        let model = {
            BranchId: this.props.branchId,
            AuditId: this.props.params ? this.props.params.id : 0,
            ProductId: product.id
        }

        this.props.removeProductInAduit(model);
    }

    addCategory = (isUncounted) => {
        const p = this.props;
        const warehouseType = p.form[isUncounted ? 'SelectedUncountedWarehouse' : 'InventoryAuditSelectedWarehouse'];
        const fCat = isUncounted ? 'SelectedUncountedCategory' : 'InventoryAuditSelectedCategory';
        const fSubCat = isUncounted ? 'SelectedUncountedSubCategory' : 'SelectedSubCategory';
        const fSubSubCat = isUncounted ? 'SelectedUncountedSubSubCategory' : 'SelectedSubSubCategory';
        const list = isUncounted ? p.auditUncountedList : p.auditCategoriesList;
        let pids = null;
        const cat = list.find(_ => _.id == p.form[fCat]);
        if (cat) {
            if (!p.form[fSubCat]) {
                pids = cat.subs.map(x => x.subsubs.map(y => y.pids).flat()).flat();
            } else {
                const name = p.form[fSubCat] === 'No Sub Category' ? null : p.form[fSubCat];
                const subcat = cat.subs.find(_ => _.name == name);
                if (subcat) {
                    if (!p.form[fSubSubCat]) {
                        pids = subcat.subsubs.map(y => y.pids).flat();
                    } else {
                        const name = p.form[fSubSubCat] === 'No Sub Sub Category' ? null : p.form[fSubSubCat];
                        const subSubcat = subcat.subsubs.find(_ => _.name == name);
                        if (subSubcat) pids = subSubcat.pids;
                    }
                }
            }
            if (pids) {
                let pidsWithWarehouse = pids.map(p => ({ Id: p, WarehouseTypeId: warehouseType }))
                this.addProductsToAudit(pidsWithWarehouse)
                // this.addProductsToAudit(pids.map(_ => ({ Id: _ })))
            }
        }
    }

    auditBrand = () => {
        const model = {
            BranchId: this.props.branchId,
            Brand: this.props.form['InventoryAuditSelectedBrand']
        };
        this.props.auditBrand(model);
    }

    sort(sortBy) {
        this.setState(prevState => {
            return {
                ...prevState,
                orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
                sortBy
            }
        }, () => this.initialProducts());
    }

    verifyProduct = (product) => {
        let newquantity = this.props.form[`InventoryAudit_${product.id}_${product.warehouseType}_Quantity`];
        let diffQty = newquantity - product.inStock;

        this.setState(prevState => {
            return {
                ...prevState,
                productId: product.id,
                warehouseType: product.warehouseType,
                countedCost: newquantity * product.wac,
                diffQty: diffQty,
                diffCost: diffQty * product.wac,
                newquantity: newquantity,
                openAdjust: true
            }
        }, () => this.props.setSelectAdjustmentProduct(product));
    }

    closeDialogAdjustment = () => {
        this.setState(prevState => {
            return {
                ...prevState,
                openAdjust: false
            }
        }, () => this.props.clearSelectAdjustmentProduct());
    }

    completeAudit = () => {
        this.props.completeAudit({ Id: this.props.params ? this.props.params.id : 0, branchId: this.props.branchId });
    }

    updateAuditName = () => {
        let model = {
            BranchId: this.props.branchId,
            AuditId: this.props.params ? this.props.params.id : 0,
            Name: this.props.inventoryAuditTitleName
        }
        this.props.updateAuditName(model);
    }

    updateAuditProductQuantity = (e, productId, warehouseType, quantity) => {
        if (quantity) {
            let model = {
                BranchId: this.props.branchId,
                AuditId: this.props.params ? this.props.params.id : 0,
                WarehouseType: warehouseType,
                ProductId: productId,
                Quantity: quantity != "" ? quantity : null,
                lockExpectedQuantity: this.props.inventoryAudit.lockExpectedQuantity
            }
            this.props.updateAuditProductQuantity(model);
        }
    }

    updateAuditProductExpectedQuantity = (productId, warehouseType, expectedQuantity) => {
        if (expectedQuantity != null && expectedQuantity != undefined) {
            let model = {
                BranchId: this.props.branchId,
                AuditId: this.props.params ? this.props.params.id : 0,
                ProductId: productId,
                WarehouseType: warehouseType,
                ExpectedQuantity: expectedQuantity
            }
            this.props.updateAuditProductExpectedQuantity(model);
        }
    }

    updateAuditProductNotes = (e, productId, warehouseType, notes) => {
        const model = {
            BranchId: this.props.branchId,
            WarehouseType: warehouseType,
            AuditId: this.props.params ? this.props.params.id : 0,
            ProductId: productId,
            Notes: notes || ``
        }
        this.props.updateAuditProductNotes(model);
    }

    onChangeProductNameSearch = (event) => {
        const value = event.target.value;
        this.setState({ productNameSearch: event.target.value });

        if (value.length > 2){
                const searchQuery = value.toUpperCase();
                const productState = this.state.sortedProducts.filter(x => x.name.toUpperCase().includes(searchQuery));
                this.setState({ productState, productLength: productState.length, activePage: 1 })
        }else if (value === ``){
            this.setState({ productNameSearch: "", productState: [], activePage: 1, sortedProducts: [] })
            this.initialProducts();
        }
    }

    onChangeProductSKUSearch = (event) => {
        const value = event.target.value;
        this.setState({ productSKUSearch: event.target.value });

        if (value.length > 2){
                const productState = this.state.sortedProducts.filter(x => x.sku === value);
                this.setState({ productState, productLength: productState.length, activePage: 1 })
        }else if (value === ``){
            this.setState({ productSKUSearch: "", productState: [], activePage: 1, sortedProducts: [] })
            this.initialProducts();
        }
    }

    setIsAdjust = () => {
        this.setState({ isAdjust: true }
        , () => setTimeout(() => {
            this.setState({
                isAdjust: false
            })
        }, 5000));
    }

    resetFilter = () => {
        this.setState({ productSKUSearch: "", productNameSearch: "", productState: [], activePage: 1, sortedProducts: [] })
        this.initialProducts();
    }

    scroll = (productId, warehouseType) => {
        if (productId) {
            const gridApi = this.agGridRef && this.agGridRef.current.api;
    
            // Find the row node using the barcode (ID) value
            const rowNode = gridApi.getRowNode(`productId${productId}`);

            if (rowNode && gridApi) {
                // Use grid API to set focus on the first editable cell in the row
                const columnId = 'newquantity'; // or any column you want to focus on

                setTimeout(() => {
                    gridApi.ensureIndexVisible(rowNode.rowIndex);
                    gridApi.setFocusedCell(rowNode.rowIndex, columnId);
                }, 100);

                gridApi.ensureNodeVisible(rowNode, 'top');
            }
        }
    };

    verifyOrRecount = () => {
        const p = this.props;
        const model = { BranchId: p.branchId, AuditId: p.params ? p.params.id : 0 };
        if (p.inventoryAudit.status == 3 && p.canManageAudit) {
            if (this.state.selectedRows.length === 0) {
                alert("Please select products that need recount");
            } else {
                p.recountAudit({ ...model, ProductIds: this.state.selectedRows.map(x => x.id) });
            }
        } else if ((p.inventoryAudit.status == 1 || p.inventoryAudit.status == 4) && !p.canManageAudit) {
            p.verifyAudit(model);
        }
    }
    changeWarehouseTypeIdToName = (warehouseId) => {
        return this.warehouses.find(x => x.value == warehouseId).text;
    }
    warehouses = [
        { text: "All", value: "0" },
        { text: "Storage", value: "1" },
        { text: "Sell", value: "2" },
        { text: "Damage", value: "3" }
    ];

    updateAuditProductDiffQty = () => {
        let model = {
            BranchId: this.props.branchId,
            WarehouseType: this.state.warehouseType,
            AuditId: this.props.params ? this.props.params.id : 0,
            ProductId: this.state.productId,
            CountedCost: this.state.countedCost,
            DiffQty: this.state.diffQty,
            DiffCost: this.state.diffCost
        }
        this.props.updateAuditProductDiffQty(model)
    }

    pageChange = (page) => {
        this.setState({
            activePage: page
        }, () => this.paginateProducts(page));
    }

    render() {
        const p = this.props;
        const breadCrumbPage = this.state.status === 'EDIT' ? auditViewCrumb : auditAddCrumb

        const categories = p.auditCategoriesList.map(_ => ({ text: `${_.name} - ${_.count}`, value: _.id }));
        const cat = p.auditCategoriesList.find(_ => _.id == p.form['InventoryAuditSelectedCategory']);
        const subs = cat ? cat.subs.map(_ => ({ text: `${_.name || 'No Sub Category'} - ${_.count}`, value: _.name || 'No Sub Category' })) : [];
        const sub = cat && cat.subs.find(_ => _.name == p.form['SelectedSubCategory']);
        const subSubs = sub ? sub.subsubs.map(_ => ({ text: `${_.name || 'No Sub Sub Category'} - ${_.count}`, value: _.name || 'No Sub Sub Category' })) : [];

        const uncounted = p.auditUncountedList.map(_ => ({ text: `${_.name} - ${_.count}`, value: _.id }));
        const uncat = p.auditUncountedList.find(_ => _.id == p.form['SelectedUncountedCategory']);
        const uncountedSub = uncat ? uncat.subs.map(_ => ({ text: `${_.name || 'No Sub Category'} - ${_.count}`, value: _.name || 'No Sub Category' })) : [];
        const uncatsub = uncat && uncat.subs.find(_ => _.name == p.form['SelectedUncountedSubCategory']);
        const uncountedSubSub = uncatsub ? uncatsub.subsubs.map(_ => ({ text: `${_.name || 'No Sub Sub Category'} - ${_.count}`, value: _.name || 'No Sub Sub Category' })) : [];

        let brands = [{ text: "All", value: "none" }];
        const bra = this.props.brandList && this.props.brandList.length > 0 ? this.props.brandList : [];
        bra.map((item) => {
            brands.push({
                text: item,
                value: item
            });
        });

        let isComplete = this.state.status !== "ADD" && (!this.props.inventoryAudit || this.props.inventoryAudit.status == 2);
        let productState = p.inventoryAuditProducts.map(x => ({
            id: x.id, name: x.name, sku: x.sku, location: x.location, BranchId: p.branchId,
            inStock: x.inStock, expectedQty: x.expectedQty, newquantity: x.newquantity, wac: x.wac, needRecount: x.needRecount,
            warehouseType: x.warehouseType, warehouseTypeName: this.changeWarehouseTypeIdToName(x.warehouseType)
        }));
        if (p.inventoryAudit.status == 4 && !p.canManageAudit) {
            productState = productState.filter(x => x.needRecount);
        }
        if (this.state.productNameSearch) {
            productState = productState.filter(x => x.name.toUpperCase().includes(this.state.productNameSearch.toUpperCase()));
        }
        const canStoreVerify = (p.inventoryAudit.status == 1 || p.inventoryAudit.status == 4) && !p.canManageAudit;
        const canOwnerRecount = p.inventoryAudit.status == 3 && p.canManageAudit;

        let columnHeaders = p.canManageAudit ? LOOKUP.inventoryAudit.auditTableManagerColumns : LOOKUP.inventoryAudit.auditTableColumns;
        const rows = this.state.productState && this.state.productState.length > 0 ? mapInventoryAudit(this.props.form, this.state.productState, this.deleteProduct, isComplete, this.verifyProduct, this.updateAuditProductQuantity, this.updateAuditProductNotes, this.props.auditUpdating, this.props.inventoryAudit.lockExpectedQuantity) : [];
        let diff = ''
        let diffCost = ''
        if (p.canManageAudit) {
            const sum = x => x.reduce((p, c) => p + c, 0);
            const negtiveRows = rows.filter(x => x.diff && x.diff < 0);
            const negtiveSum = sum(negtiveRows.map(x => x.diff))
            const negtiveCostSum = sum(negtiveRows.map(x => x.diffCost))
            const positiveRows = rows.filter(x => x.diff && x.diff > 0);
            const positiveSum = sum(positiveRows.map(x => x.diff))
            const positiveCostSum = sum(positiveRows.map(x => x.diffCost))
            diff = `\n {${negtiveSum.toFixed(0)}, +${positiveSum.toFixed(0)}}`
            diffCost = `\n {${negtiveCostSum.toFixed(0)}, +${positiveCostSum.toFixed(0)}}`
        }
        columnHeaders = columnHeaders.map(x => ({ ...x, label: x.label.replace('{$0}', diff).replace('{$1}', diffCost) }))

        return (
            <Grid headerContent={breadCrumbPage}>
                <PageHeader title="Inventory Audit" />
                {
                    isComplete ?
                        <CardSimple title="General">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <h5>Created Date: {this.props.inventoryAudit ? moment(this.props.inventoryAudit.createdDate).format('YYYY-MM-DD') : ""}</h5>
                                    <h5>Modified Date: {this.props.inventoryAudit ? moment(this.props.inventoryAudit.modifiedDate).format('YYYY-MM-DD') : ""}</h5>
                                    <h5>{this.props.inventoryAudit && this.props.inventoryAudit.completedDate && <span>Completed Date: {moment(this.props.inventoryAudit.completedDate).format('YYYY-MM-DD')}</span>}</h5>
                                    <h5>{this.props.inventoryAudit && this.props.inventoryAudit.completedDate && <span>Completed By: {this.props.inventoryAudit.employee}</span>}</h5>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-2">
                                    <TextInputOnBlurCallApi
                                        name="InventoryAuditTitleName"
                                        fullWidth={true}
                                        label="Inventory Audit Name"
                                        floatingLabelText="Inventory Audit Name"
                                        hintText="Inventory Audit Name"
                                        className="InventoryAuditName"
                                        onBlur={this.updateAuditName}
                                        disabled={this.props.auditUpdating} />
                                    <br />
                                </div>
                            </div>
                        </CardSimple>
                        :
                        <React.Fragment>
                            <CardSimple title="General">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                                        <h5>Created Date: {this.props.inventoryAudit ? moment(this.props.inventoryAudit.createdDate).format('YYYY-MM-DD') : ""}</h5>
                                        <h5>Modified Date: {this.props.inventoryAudit ? moment(this.props.inventoryAudit.modifiedDate).format('YYYY-MM-DD') : ""}</h5>
                                    </div>
                                    {
                                        this.props.canManageAudit &&
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <Button
                                                name='saveButton'
                                                className='mb-2'
                                                label="Complete"
                                                primary={true}
                                                onTouchTap={() => this.completeAudit()}
                                            />
                                            <p>Note: All Expected Quantity must equal Counted Quantity to complete audit.</p>
                                        </div>
                                    }
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-2">
                                        <TextInputOnBlurCallApi
                                            name="InventoryAuditTitleName"
                                            fullWidth={true}
                                            label="Inventory Audit Name"
                                            floatingLabelText="Inventory Audit Name"
                                            hintText="Inventory Audit Name"
                                            className="InventoryAuditName"
                                            onBlur={this.updateAuditName}
                                            disabled={this.props.auditUpdating} />
                                        <br />
                                    </div>
                                </div>
                            </CardSimple>
                            <CardSimple title="Add Category to Audit">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-3 pull-left">
                                        <SelectInput
                                            name="InventoryAuditSelectedWarehouse"
                                            label="Warehouse"
                                            floatingLabelText="Warehouse"
                                            hintText="Warehouse"
                                            options={this.warehouses}
                                            defaultValue="0"
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-3 pull-left">
                                        <SelectInput
                                            name="InventoryAuditSelectedCategory"
                                            id="selectCategory"
                                            fullWidth={true}
                                            label="Category"
                                            floatingLabelText="Category"
                                            hintText="Category"
                                            options={categories}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-3 pull-left">
                                        <SelectInput
                                            name={"SelectedSubCategory"}
                                            fullWidth={true}
                                            label={"Sub Category"}
                                            floatingLabelText={"Sub Category"}
                                            hintText={"Sub Category"}
                                            options={subs}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-3 pull-left">
                                        <SelectInput
                                            name={"SelectedSubSubCategory"}
                                            fullWidth={true}
                                            label={"Sub Sub Category"}
                                            floatingLabelText={"Sub Sub Category"}
                                            hintText={"Sub Sub Category"}
                                            options={subSubs}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 text-right">
                                        <Button
                                            name='categoryButton'
                                            label='Import'
                                            primary={true}
                                            onTouchTap={() => this.addCategory(false)} />
                                    </div>
                                </div>
                            </CardSimple>
                            <CardSimple title="Add Brand Products to Audit">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 pull-left">
                                        <SelectInput
                                            name={"InventoryAuditSelectedWarehouse"}
                                            label={"Warehouse"}
                                            floatingLabelText={"Warehouse"}
                                            hintText={"Warehouse"}
                                            options={this.warehouses}
                                            defaultValue="0"
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-3 pull-left">
                                        <SelectInput
                                            name={"InventoryAuditSelectedBrand"}
                                            id="selectBrand"
                                            fullWidth={true}
                                            label={"Brand"}
                                            floatingLabelText={"Brand"}
                                            hintText={"Brand"}
                                            options={brands}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2 mt-2 pull-left">
                                        <Button
                                            name="brandButton"
                                            label="Import"
                                            primary={true}
                                            onTouchTap={() => this.auditBrand()} />
                                    </div>
                                </div>
                            </CardSimple>
                            <CardSimple title="Add Product to Audit">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 pull-left">
                                        <SelectInput
                                            name={"InventoryAuditSelectedWarehouse"}
                                            fullWidth={true}
                                            label={"Warehouse"}
                                            floatingLabelText={"Warehouse"}
                                            hintText={"Warehouse"}
                                            options={this.warehouses}
                                            defaultValue="0"
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                                        <AuditProductSave
                                            name={`InventoryAudit`}
                                            floatingLabelText={"Search an existing product"}
                                            hintText={"Product"}
                                            fullWidth={true}
                                            options={p.products}
                                            addProduct={this.addProduct} />
                                        <br />
                                    </div>
                                </div>
                            </CardSimple>
                            <CardSimple title="Add Uncounted Products to Audit">
                                <div className="row">
                                    <div className="col-xs-5 col-sm-6 col-md-6 col-lg-5 col-xl-3 pull-left">
                                        <DatePickerInput
                                            name={"UncountedCutoffDate"}
                                            floatingLabelText={"Date"}
                                            hintText={"Date"}
                                            fullWidth={true}
                                        />
                                    </div>
                                    <div className="col-xs-5 col-sm-6 col-md-6 col-lg-5 col-xl-3 pull-left">
                                        <SelectInput
                                            name={"SelectedUncountedWarehouse"}
                                            label={"Warehouse"}
                                            floatingLabelText={"Warehouse"}
                                            hintText={"Warehouse"}
                                            options={this.warehouses}
                                            defaultValue="0"
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-3 pull-left">
                                        <SelectInput
                                            name={"SelectedUncountedCategory"}
                                            fullWidth={true}
                                            label={"Uncounted by Category"}
                                            floatingLabelText={"Uncounted by Category"}
                                            hintText={"Uncounted by Category"}
                                            options={uncounted}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-3 pull-left">
                                        <SelectInput
                                            name={"SelectedUncountedSubCategory"}
                                            fullWidth={true}
                                            label={"Sub Category"}
                                            floatingLabelText={"Sub Category"}
                                            hintText={"Sub Category"}
                                            options={uncountedSub}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-3 pull-left">
                                        <SelectInput
                                            name={"SelectedUncountedSubSubCategory"}
                                            fullWidth={true}
                                            label={"Sub Sub Category"}
                                            floatingLabelText={"Sub Sub Category"}
                                            hintText={"Sub Sub Category"}
                                            options={uncountedSubSub}
                                        />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-9 pt-2 text-right">
                                        <Button
                                            name='uncountedButton'
                                            label='Import'
                                            primary={true}
                                            onTouchTap={() => this.addCategory(true)} />
                                    </div>
                                </div>
                            </CardSimple>
                        </React.Fragment>
                }
                <CardSimple>
                    <div className="row">
                        <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                            <p className="size_1-1vmax fw_bold orange-text">Warning: Ensure your cursor is not inside an input field when scanning a product for audit!</p>
                            {this.props.inventoryAudit.lockExpectedQuantity ? <p className="size_1-1vmax fw_bold">Expected Quantity will be LOCKED after entering Counted Quantity for the first time!</p> : null}
                        </div>
                        {(canStoreVerify || canOwnerRecount) &&
                            <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2" style={{ textAlign: "right", paddingRight: "30px" }}>
                                <Button
                                    name="transitionButton"
                                    label={p.inventoryAudit.status == 3 && p.canManageAudit ? "Recount" : "Verify"}
                                    primary={true}
                                    onTouchTap={() => this.verifyOrRecount()} />
                            </div>
                        }
                    </div>
                    <DataGrid isComplete={isComplete} verifyProduct={this.verifyProduct} lockExpectedQuantity={this.props.inventoryAudit.lockExpectedQuantity} 
                        auditUpdating={this.props.auditUpdating} deleteProduct={this.deleteProduct} rows={this.state.sortedProducts} 
                        agGridRef={this.agGridRef}
                        canManageAudit={this.props.canManageAudit}
                        canOwnerRecount={canOwnerRecount}
                        canStoreVerify={canStoreVerify}
                        onRowSelection={(selectedRows) => this.setState({ selectedRows })}
                    />
                </CardSimple>

                {this.state.openAdjust ?
                    <AdjustInventoryDialog name="adjustmentInventoryDialog"
                        productId={this.state.productId}
                        newquantity={this.state.newquantity}
                        lockExpectedQuantity={this.props.inventoryAudit.lockExpectedQuantity}
                        updateAuditProductExpectedQuantity={this.updateAuditProductExpectedQuantity}
                        updateAuditProductDiffQty={this.updateAuditProductDiffQty}
                        openAdjust={this.state.openAdjust}
                        placeOfInventoryChange={"5"}
                        onClose={this.closeDialogAdjustment} 
                        setIsAdjust={this.setIsAdjust}
                        audit={this.props.inventoryAudit}
                        /> : ""
                }
            </Grid>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        branchId: state.common.branchId,
        inventoryAuditModel: selectInventoryAuditModel(state, "InventoryAudit"),
        productTypes: state.entity.productTypesList,
        products: state.entity.products,
        auditCategoryList: state.entity.auditCategoryList || [],
        auditCategoriesList: state.entity.auditCategoriesList || [],
        auditUncountedList: state.entity.auditUncountedList || [],
        inventoryAudit: state.entity.inventoryAudit,
        inventoryAuditProducts: state.entity.inventoryAudit ? state.entity.inventoryAudit.products : [],
        form: state.form,
        brandList: state.entity.brandList || [],
        auditBrandList: state.entity.auditBrandList || [],
        auditCategoryListTimeStamp: state.entity.auditCategoryListTimeStamp,
        auditBrandListTimeStamp: state.entity.auditBrandListTimeStamp,
        saveSuccess: state.form["InventoryAuditSaveTimeStamp"],
        canManageAudit: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanManageAudit")),
        adjustProductSuccessTimeStamp: state.entity.adjustProductSuccessTimeStamp,
        inventoryAuditTitleName: state.form["InventoryAuditTitleName"],
        auditUpdating: state.common.auditUpdating > 0,
        inventoryAuditScan: state.entity.inventoryAuditScan,
        inventoryAuditUpdateScanned: state.entity.inventoryAuditUpdateScanned,
        uncountedCutoffDate: state.form["UncountedCutoffDate"]
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        showAuditSuccess: (message) => dispatch(showSnackbar(message)),
        getProductTypes: () => dispatch(getProductTypes()),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        getAudit: (model) => dispatch(getAudit(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (value, name) => dispatch(clearFormInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        auditCategory: (model) => dispatch(auditCategory(model)),
        getBrands: () => dispatch(getBrands()),
        auditBrand: (model) => dispatch(auditBrand(model)),
        getAudits: (model) => dispatch(getAudits(model)),
        clearProductTypeList: () => dispatch(clearProductTypeList()),
        clearBrandList: () => dispatch(clearBrandList()),
        clearInventoryAudit: () => dispatch(clearInventoryAudit()),
        completeAudit: (model) => dispatch(completeAudit(model)),
        verifyAudit: (model) => dispatch(verifyAudit(model)),
        recountAudit: (model) => dispatch(recountAudit(model)),
        removeProductInAduit: (model) => dispatch(removeProductInAduit(model)),
        addProductsToAduit: (model) => dispatch(addProductsToAduit(model)),
        updateAuditProductQuantity: (model) => dispatch(updateAuditProductQuantity(model)),
        updateAuditProductExpectedQuantity: (model) => dispatch(updateAuditProductExpectedQuantity(model)),
        updateAuditProductNotes: (model) => dispatch(updateAuditProductNotes(model)),
        updateAuditName: (model) => dispatch(updateAuditName(model)),
        clearSelectAdjustmentProduct: () => dispatch(clearSelectAdjustmentProduct()),
        setSelectAdjustmentProduct: (product) => dispatch(setSelectAdjustmentProduct(product)),
        getProductsBarcodeInventoryAudit: (model) => dispatch(getProductsBarcodeInventoryAudit(model)),
        getAuditUncounted: (model) => dispatch(getAuditUncounted(model)),
        getAuditCategories: (model) => dispatch(getAuditCategories(model)),
        updateAuditProductDiffQty: (model) => dispatch(updateAuditProductDiffQty(model))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(InventoryAudit));
